/* =====================================================================
   HL LONDON — TRUE QUICK-ADD (Shopability P0)
   Drives snippets/hl-quick-add.liquid on collection, search and homepage
   grids. Everything is delegated off document, so cards appended by
   "LOAD MORE PRODUCTS" and by the AJAX filter/sort paths are live the
   moment they land — no re-initialisation hook to forget to call.

   It never adds to the cart itself. It fills the form's hidden id and
   submits; snippets/cart-drawer.liquid catches the submit during capture,
   POSTs to /cart/add.js and opens the drawer. One cart client, one AJAX
   path, and the cart-drawer fetch patch is untouched.
   ===================================================================== */
(function () {
  'use strict';

  var OPEN = 'hlqa--open';
  var BUSY = 'hlqa--busy';

  function closeAll(except) {
    document.querySelectorAll('.' + OPEN).forEach(function (el) {
      if (el === except) return;
      el.classList.remove(OPEN);
      var sheet = el.querySelector('.hlqa__sheet');
      if (sheet) sheet.hidden = true;
      var trigger = el.querySelector('[data-hlqa-open]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  /* Submit the card's form. requestSubmit() where it exists so the browser
     runs the normal submit pipeline; the dispatched fallback is for older
     WebKit, and it is cancelable so cart-drawer's preventDefault still
     stops the navigation. */
  function submitForm(form) {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function add(root, variantId) {
    var form = root.querySelector('form');
    if (!form || root.classList.contains(BUSY)) return;
    var idInput = form.querySelector('[data-hlqa-id]');
    if (variantId) {
      if (!idInput) return;
      idInput.value = variantId;
    }
    if (!idInput || !idInput.value) return;

    root.classList.add(BUSY);
    submitForm(form);

    /* The drawer opening is the real confirmation; this only clears the
       card's own pressed state, and closes the size sheet behind it. */
    window.setTimeout(function () {
      root.classList.remove(BUSY);
      root.classList.remove(OPEN);
      var sheet = root.querySelector('.hlqa__sheet');
      if (sheet) sheet.hidden = true;
      var trigger = root.querySelector('[data-hlqa-open]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }, 900);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-hlqa-open]');
    if (opener) {
      /* The card is a link; opening the picker must not follow it. */
      e.preventDefault();
      e.stopPropagation();
      var root = opener.closest('[data-hlqa]');
      if (!root) return;
      var isOpen = root.classList.contains(OPEN);
      closeAll(root);
      var sheet = root.querySelector('.hlqa__sheet');
      if (isOpen) {
        root.classList.remove(OPEN);
        if (sheet) sheet.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
      } else {
        if (sheet) sheet.hidden = false;
        root.classList.add(OPEN);
        opener.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var closer = t.closest('[data-hlqa-close]');
    if (closer) {
      e.preventDefault();
      e.stopPropagation();
      closeAll(null);
      return;
    }

    var size = t.closest('.hlqa__size');
    if (size && !size.disabled) {
      e.preventDefault();
      e.stopPropagation();
      var sroot = size.closest('[data-hlqa]');
      if (sroot) add(sroot, size.getAttribute('data-hlqa-variant'));
      return;
    }

    var direct = t.closest('[data-hlqa-add]');
    if (direct) {
      e.preventDefault();
      e.stopPropagation();
      var droot = direct.closest('[data-hlqa]');
      if (droot) add(droot, null);
      return;
    }

    /* A tap anywhere else dismisses an open picker rather than adding a
       size the shopper has scrolled away from. */
    if (!t.closest('.hlqa__sheet')) closeAll(null);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
